/** Normalize a phone value to the single +91XXXXXXXXXX form used by auth. */
export const normalizePhone = (phone) => {
  const raw = String(phone || '');
  const digits = raw.replace(/\D/g, '');
  if (digits.length < 10) return raw;
  const clean10 = digits.slice(-10);
  return `+91${clean10}`;
};

/** Return a valid Indian number for wa.me (91XXXXXXXXXX, without +). */
export const normalizePhoneForWhatsapp = (phone) => {
  const normalized = normalizePhone(phone);
  return /^\+91\d{10}$/.test(normalized) ? normalized.slice(1) : '';
};
